import { SavePickSitePayloadModelBase } from './SavePickSitePayloadModel.base'

/* A graphql query fragment builders for SavePickSitePayloadModel */
export {
  selectFromSavePickSitePayload,
  savePickSitePayloadModelPrimitives,
  SavePickSitePayloadModelSelector,
} from './SavePickSitePayloadModel.base'

/**
 * SavePickSitePayloadModel
 *
 * Autogenerated return type of SavePickSite
 */
export const SavePickSitePayloadModel = SavePickSitePayloadModelBase.actions(
  (self) => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    },
  })
)
